// Port of api/fuel/app/classes/controller/api/monty/designers/suggest.php
import DB from 'offline/db'
import Util from 'offline/util'
export default function(params) {
	var text = (params.text || '').toLowerCase()
	var exclude = params.exclude || [0]
	if (!text) return Promise.resolve({ session: { offline: true }, data: { suggestions: {} } })
	var rows = DB.query("SELECT designer_id, designer_name FROM designer WHERE LOWER(designer_name) LIKE '%" + text.replace(/'/g, "''") + "%' AND designer_id NOT IN(" + Util.in(exclude) + ") LIMIT 25")
	var suggestions = {}
	for (var i = 0; i < rows.length; i++) suggestions[rows[i].designer_id] = { id: rows[i].designer_id, name: rows[i].designer_name }
	return Promise.resolve({ session: { offline: true }, data: { suggestions: suggestions } })
}
